(() => {
  // Native GET keeps selected variant, price, availability and unit price in one server render.
  document.querySelectorAll('[data-hk-variant]').forEach(select => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });
  document.querySelectorAll('.mobile-nav').forEach(menu => {
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    menu.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      menu.open = false; menu.querySelector('summary')?.focus();
    }));
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary')?.focus(); }
    });
  });
  const dealer = document.querySelector('.dealer-mail-fallback');
  if (dealer) {
    const field = dealer.querySelector('textarea');
    const status = dealer.querySelector('[role="status"]');
    const buttons = dealer.querySelectorAll('button');
    buttons.forEach((button, index) => button.addEventListener('click', async () => {
      const email = dealer.querySelector('.dealer-email-address').textContent.trim();
      const text = index === 0 ? email : `An: ${email}\nBetreff: HULZKNECHT – Händler- oder Firmenanfrage\n\n${field.value}`;
      try { await navigator.clipboard.writeText(text); status.textContent = 'Kopiert. Ergänze die Anfrage in deiner E-Mail-App.'; }
      catch { field.focus(); field.select(); status.textContent = 'Bitte kopiere den markierten Text und die oben angegebene E-Mail-Adresse.'; }
    }));
  }
})();
